import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import { I18nProvider } from "./i18n/I18nContext.js";
import { AuthProvider } from "./context/AuthContext.js";
import { PlayerProvider } from "./context/PlayerContext.js";
import "./styles.css";

// Client-Side URL Sanitizer: Cleanly rewrite /index.html to / without full reload
if (typeof window !== "undefined") {
  const pathname = window.location.pathname;
  if (pathname === "/index.html" || pathname.endsWith("/index.html")) {
    const cleanPath = pathname.replace(/\/index\.html$/, "") || "/";
    window.history.replaceState(null, "", cleanPath + window.location.search + window.location.hash);
  }
}

const rootElement = document.getElementById("root");

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <I18nProvider>
        <AuthProvider>
          <PlayerProvider>
            <App />
          </PlayerProvider>
        </AuthProvider>
      </I18nProvider>
    </React.StrictMode>
  );
}

// Service Worker Registration for PWA & Offline Video Caching
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "test") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("[PWA] Service Worker registered with scope:", reg.scope);
      })
      .catch((err) => {
        console.warn("[PWA] Service Worker registration failed:", err);
      });
  });
}
